import { ApiError } from '@/api/http/types'
import type { Campaign, CampaignStatus } from '../types'

export const CAMPAIGN_LIST_ROW_BORDER = '#e5e7eb'
export const CAMPAIGN_LIST_SECONDARY = '#64748b'

export function campaignDisplayName(name: string): string {
  return name.trim() || 'Untitled campaign'
}

export function statusLabel(status: CampaignStatus): string {
  switch (status) {
    case 'draft':
      return 'Draft'
    case 'inactive':
      return 'Saved'
    case 'goal_analysis':
      return 'Goal analysis'
    case 'lines_of_inquiry':
      return 'Lines of inquiry'
    case 'active':
      return 'Active'
    case 'completed':
      return 'Completed'
    default:
      return status
  }
}

export function statusChipColor(status: CampaignStatus): 'default' | 'primary' | 'success' | 'warning' {
  if (status === 'active') return 'success'
  if (status === 'completed') return 'default'
  if (status === 'draft' || status === 'inactive') return 'default'
  if (status === 'goal_analysis') return 'warning'
  return 'primary'
}

export function formatCampaignUpdated(iso: string): string {
  const t = new Date(iso).getTime()
  if (!Number.isFinite(t)) return '—'
  return new Date(iso).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}

export function isDraftOrSavedCampaign(campaign: Campaign): boolean {
  return campaign.status === 'draft' || campaign.status === 'inactive'
}

export function deleteCampaignFailureMessage(error: unknown): string {
  if (error instanceof ApiError && error.message.trim()) {
    return error.message
  }
  return 'Could not delete campaign. Try again.'
}
